import React, { createContext, useState, useMemo } from 'react';

export const EditContext = createContext();

export const EditProvider = ({ children }) => {
    const [currId,setCurrId]=useState(null);
    const [customerId,setCustomerId]=useState(null);

  // A fresh object literal here made every consumer (MeetingForm among them)
  // re-render on every EditProvider render, not just when currId/customerId
  // actually changed - since this sits near the root of the provider tree,
  // that meant an unrelated state change anywhere upstream could still
  // cascade into every open form re-rendering (and, in MeetingForm's case,
  // re-firing a data-fetch effect keyed on this same object).
  const value = useMemo(
    () => ({ currId, setCurrId, customerId, setCustomerId }),
    [currId, customerId]
  );

  return (
    <EditContext.Provider value={value}>
      {children}
    </EditContext.Provider>
  );
};
